<template>
    <div class="luilui-shell">
        <div class="w-view-shell">
            <div class="crumbs-shell">
                当前位置：
                名师风采
                > <a href="jascript:;">名师简介</a>
            </div>
            <div class="teacher-box">
                <img :src="info.lector_img" alt="" class="teacher-img">
                <div class="teacher-info">
                    <div class="teacher-name">
                        <div class="name">{{info.lector_name}}</div>
                    </div>
                    <div class="teacher-desc">{{info.lector_desc}}</div>
                </div>
            </div>
            <div class="course-list">
                <div class="course-title">
                    全部课程({{info.course_list.length}})
                </div>
                <div class="list">
                    <router-link class="course-box" v-for="(item,index) in info.course_list" :key="index"
                                 :to="'/Coursetobuy?course_id='+item.course_id">
                        <img :src="item.course_img" alt="" class="course-img">
                        <div class="info-box">
                            <div class="course-name">
                                {{item.course_name.length>13?item.course_name.substring(0,10)+'...':item.course_name}}
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'detail',
    data () {
      return {
        lector_id: 0,
        info: {
          course_list: []
        }
      }
    },
    mounted () {
      if (this.$route.query.lector_id) {
        this.lector_id = this.$route.query.lector_id
        this.get_detail()
      }
    },
    methods: {
      get_detail () {
        this.API.post('Home/lector_out-get_teacher_info', {
          lector_id: this.lector_id
        }).then((res) => {
          this.info = res.data.lector_info
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .luilui-shell {
        background-color: #fff;

        .crumbs-shell {
            display: flex;
            align-items: center;
            height: 86px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
        }
    }

    .teacher-box {
        display: flex;
        border-bottom: 1px solid #dcdcdc;
        padding: 20px 30px;
        overflow: hidden;
        cursor: pointer;
        width: 1200px;
        min-height: 246px;
        border: 1px solid #EEEEEE;

        .teacher-img {
            width: 150px;
            min-width: 150px;
            height: 150px;
            margin-right: 20px;
        }

        .teacher-info {
            width: 90%;
        }

        .teacher-name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            margin-bottom: 20px;

            .name {
                width: 80%;
            }
        }

        .coures-num {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2AA9B5;
            margin-top: -10px;
        }

        .teacher-desc {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
        }
    }

    .course-title {
        display: flex;
        align-items: center;
        height: 86px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
    }

    .course-box {
        margin: 0 25px 40px 0;
    }

    .list {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .list a:nth-child(4n) {
        margin-right: 0 !important;
    }

    .course-img {
        width: 280px;
        height: 170px;
        margin-bottom: 20px;
    }

    .course-name {
        width: 280px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 600;
        color: #333333;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        -o-text-overflow: ellipsis; /* for Opera */
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>
